import { toast } from "sonner";
import { CAMPAIGNS } from "../../data/adminData";
import { fmt } from "../../data/store";
import { PageTitle, Table, Badge, Btn, dt, Card } from "./ui";

const COLOR = { "Aktīva": "green", "Nosūtīta": "black", "Automātiska": "amber", "Melnraksts": "gray" };

export default function Campaigns() {
  const totalRevenue = CAMPAIGNS.reduce((s, c) => s + c.revenue, 0);
  return (
    <div data-testid="admin-campaigns">
      <PageTitle right={<Btn variant="red" onClick={() => toast.info("Jauna kampaņa (DEMO)", { description: "Pilnajā versijā atvērtos e-pasta redaktors ar sagatavēm." })} data-testid="campaign-add">+ Jauna kampaņa</Btn>}>
        E-pasta kampaņas ({CAMPAIGNS.length})
      </PageTitle>
      <Card className="p-4 mb-4 flex flex-wrap gap-8">
        <div><div className="text-xs uppercase tracking-widest text-[#6B6B6B] font-bold">Abonenti</div><div className="text-xl font-extrabold">2 894</div></div>
        <div><div className="text-xs uppercase tracking-widest text-[#6B6B6B] font-bold">Vid. atvēršanas līmenis</div><div className="text-xl font-extrabold">42%</div></div>
        <div><div className="text-xs uppercase tracking-widest text-[#6B6B6B] font-bold">Ieņēmumi no kampaņām</div><div className="text-xl font-extrabold text-[#1E9E45]">{fmt(totalRevenue)}</div></div>
      </Card>
      <Table head={["Kampaņa", "Statuss", "Nosūtīts", "Atvēra", "Klikšķināja", "Ieņēmumi", "Datums", ""]} minWidth="860px">
        {CAMPAIGNS.map((c) => (
          <tr key={c.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`campaign-row-${c.id}`}>
            <td className="p-3 font-bold max-w-[240px] truncate">{c.name}</td>
            <td><Badge color={COLOR[c.status]}>{c.status}</Badge></td>
            <td>{c.sent || "—"}</td>
            <td>{c.sent ? `${c.opened}%` : "—"}</td>
            <td>{c.sent ? `${c.clicked}%` : "—"}</td>
            <td className="font-bold">{c.revenue ? fmt(c.revenue) : "—"}</td>
            <td className="text-[#6B6B6B]">{dt(c.date)}</td>
            <td className="p-3">
              {c.status === "Melnraksts"
                ? <Btn variant="red" onClick={() => toast.success("Kampaņa nosūtīta (DEMO)", { description: "2 894 abonentiem." })} data-testid={`campaign-send-${c.id}`}>Nosūtīt</Btn>
                : <Btn variant="outline" onClick={() => toast.info("Kampaņas statistika (DEMO)")} data-testid={`campaign-stats-${c.id}`}>Statistika</Btn>}
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
